
import { useParams } from "react-router-dom";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { toast } from "sonner";
import { InterfaceModelContent } from "@/components/interface/InterfaceModelContent";
import { Card } from "@/components/ui/card";
import { useInterfaceModel } from "@/hooks/useInterfaceModel";

const BusinessInterface = () => {
  const { businessTypeId } = useParams();
  const { data: interfaceModel, isLoading, error } = useInterfaceModel(businessTypeId);

  if (isLoading) {
    return (
      <DashboardLayout userType="owner">
        <div>Chargement...</div>
      </DashboardLayout>
    );
  }

  if (error) {
    console.error("Erreur lors du chargement de l'interface:", error);
    return (
      <DashboardLayout userType="owner">
        <Card className="p-6">
          <p className="text-red-500">Une erreur est survenue lors du chargement de l'interface</p>
        </Card>
      </DashboardLayout>
    );
  }

  if (!interfaceModel) {
    console.log("Aucun modèle d'interface trouvé");
    return (
      <DashboardLayout userType="owner">
        <Card className="p-6">
          <p className="text-amber-500">Configuration de l'interface en cours...</p>
          <p className="mt-2 text-sm text-gray-600">
            Veuillez contacter l'administrateur si ce message persiste.
          </p>
        </Card>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout userType="owner">
      <InterfaceModelContent
        interfaceModel={interfaceModel}
        sampleData={[]}
        onDelete={() => {
          console.log("Delete clicked");
          toast.success("Produit supprimé");
        }}
        businessTypeId={businessTypeId}
      />
    </DashboardLayout>
  );
};

export default BusinessInterface;
